import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Instagram, Youtube, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-800 text-gray-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <img src="/logo.png" alt="Christian D Animator" loading="lazy" decoding="async" className="h-8 w-auto object-contain" />
              <h3 className="text-white text-lg font-semibold flex items-center gap-2">
                Christian D Animator
                <span className="relative flex h-2 w-2" title="Available for work">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-lime-400 opacity-60"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-lime-400"></span>
                </span>
              </h3>
            </div>
            <p className="text-sm mb-4">
              Motion Designer · Animator · Video Editor · Photographer
            </p>
            <p className="text-sm mb-3">
              Bringing stories to life — one frame at a time.
            </p>
            <p className="text-xs text-gray-500 inline-flex items-center gap-1.5" data-testid="footer-location">
              <MapPin size={12} className="text-lime-400" />
              Based in Mansfield, TX · Serving the DFW Metroplex
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-sm hover:text-blue-400 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-sm hover:text-blue-400 transition-colors">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-blue-400 transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-blue-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Connect</h4>
            <div className="flex space-x-4 mb-4">
              <a
                href="mailto:christiandanimator@gmail.com"
                className="text-gray-400 hover:text-blue-400 transition-colors"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-blue-400 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-blue-400 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-blue-400 transition-colors"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </a>
            </div>
            <p className="text-sm">
              <a
                href="mailto:christiandanimator@gmail.com"
                className="hover:text-blue-400 transition-colors"
              >
                christiandanimator@gmail.com
              </a>
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>© {currentYear} Christian D Animator. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;